module.exports = function() {
  return new Worker(__webpack_public_path__ + "5ac8aeaa22fb07dd20cf.worker.js");
};